import { render, staticRenderFns } from "./TestExam.vue?vue&type=template&id=00d30b65&scoped=true&"
import script from "./TestExam.vue?vue&type=script&lang=js&"
export * from "./TestExam.vue?vue&type=script&lang=js&"
import style0 from "./TestExam.vue?vue&type=style&index=0&id=00d30b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d30b65",
  null
  
)

export default component.exports